import * as React from "react";

import type { createQueryNormalizer } from "./create-query-normalizer";

export const QueryNormalizerContext = React.createContext<
	undefined | ReturnType<typeof createQueryNormalizer>
>(undefined);

export const useQueryNormalizer = () => {
	const queryNormalizer = React.useContext(QueryNormalizerContext);

	if (!queryNormalizer) {
		throw new Error(
			"No QueryNormalizer set, use QueryNormalizerProvider to set one",
		);
	}

	return queryNormalizer;
};
